import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ColDef } from '@ag-grid-community/core'
import { StatisticalAnalysisDatasourceExternalDetail } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-datasource'
import { Nullable } from '@/shared/types/app.types'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisDossiersDatasourceResponsesTypes, StatisticalAnalysisDynamicObject, StatisticalAnalysisExternalListTypes, StatisticalAnalysisViewDetailTableGroupingColumns } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { StatisticalAnalysisViewDetailTableFilters } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-table/statistical-analysis-view-detail-table.model'
import { store } from '@/store/store'
import { activityStatisticsDossierService } from '@/modules/statistical-analysis-module/services/activity-dossier/activity-dossier.service'
import { StatisticalAnalysisActivityDossierExternalInfo } from '@/modules/statistical-analysis-module/views/service-activity-dossier/service-activity-dossier.model'
import { StatisticalAnalysisActivityStatisticsDossierBaseRequest, StatisticalAnalysisActivityStatisticsDossierDetailExternalViewTable, StatisticalAnalysisActivityStatisticsDossierDetailViewTableContentCase } from '@/modules/statistical-analysis-module/services/activity-dossier/activity-dossier.dto'
import { chain, isNil } from 'lodash'
import { StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import { getExternalColumnsEntity, getLabAndCaseId, parseGroupingParams } from '@/modules/statistical-analysis-module/shared/helpers/helpers'
import { InfinitePaginatorResponse } from '@/shared/resources/infinite-datasources/infinite-resource.model'

export class StatisticalAnalysisHandlerDatasourceActivityDossierDetailList extends StatisticalAnalysisDatasourceExternalDetail<StatisticalAnalysisExternalListTypes> {
    protected statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailTableFilters>
    protected row: StatisticalAnalysisActivityStatisticsDossierDetailViewTableContentCase

    constructor(statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailTableFilters>, row: StatisticalAnalysisDossiersDatasourceResponsesTypes) {
        super()
        this.statisticalAnalysisFilters = statisticalAnalysisFilters
        this.row = row as StatisticalAnalysisActivityStatisticsDossierDetailViewTableContentCase
    }

    public getGridColumns(): ColDef[] {
        return getExternalColumnsEntity((this.statisticalAnalysisFilters?.externalFiltering.sidebarFilters?.typeSearch as StatisticalAnalysisSidebarItemCombo)?.id as StatiscalAnalysisTypeCases)
    }

    public async paginator(filterModel: CommonFilterModel, params: CommonParams, scrollId: string): Promise<InfinitePaginatorResponse<StatisticalAnalysisExternalListTypes>> {
        const sidebarFilter = this.statisticalAnalysisFilters?.externalFiltering.sidebarFilters as StatisticalAnalysisActivityDossierExternalInfo
        const baseRequest: StatisticalAnalysisActivityStatisticsDossierBaseRequest = activityStatisticsDossierService.getBaseRequest(sidebarFilter)
        const typeCase = sidebarFilter?.typeSearch?.id as StatiscalAnalysisTypeCases
        const groupingParams: StatisticalAnalysisDynamicObject = chain(this.row)
            .omitBy((_value: unknown, key: string) =>
                key.startsWith('reportUCL') || key.startsWith('totalCases') || key.startsWith('totalUCL') ||
                key.startsWith('totalURV') || key.startsWith('macroUCL')
            )
            .omitBy((value: unknown) => value === null)
            .reduce((aggr: StatisticalAnalysisDynamicObject, value: unknown) => {
                return parseGroupingParams(aggr, value as StatisticalAnalysisViewDetailTableGroupingColumns)
            }, {})
            .value()
        const response: StatisticalAnalysisActivityStatisticsDossierDetailExternalViewTable = await activityStatisticsDossierService.getExternalViewDetailList(filterModel, params, baseRequest, groupingParams, typeCase, scrollId, this.getTotalElements())
        if (isNil(this.getTotalElements())) {
            this.setTotalElements(response.scrollPage.totalElements)
        }
        return {
            content: response.content,
            scrollPage: {
                scrollId: encodeURIComponent(JSON.stringify(response.scrollPage.scrollId)),
                size: response.scrollPage.size,
                totalElements: response.scrollPage.totalElements
            }
        }
    }

    public getLabAndCaseId(selectedRow: StatisticalAnalysisExternalListTypes): [number, number] {
        const sidebarFilter = this.statisticalAnalysisFilters?.externalFiltering.sidebarFilters as StatisticalAnalysisActivityDossierExternalInfo
        const typeCase = sidebarFilter?.typeSearch?.id as StatiscalAnalysisTypeCases
        return getLabAndCaseId(typeCase, selectedRow)
    }
}
